import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { OutputDataUrl } from './OutputDataUrl';
import { ConfirmTimeSeriesType } from '../schema/types';
import { ConfirmTimeSeriesMutationSchema } from '../schema/OutputDataSchema';

const postConfirmTimeSeriesOutputData = async (
  request: ConfirmTimeSeriesType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<void>(
      OutputDataUrl.OUTPUT_DATA_TIMESERIES_CONFIRMATIONS,
      ConfirmTimeSeriesMutationSchema.parse(request),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useConfirmTimeSeriesOutputData = createApiMutationHook(
  ['confirmTimeSeriesOutputData'],
  getMutationFn(postConfirmTimeSeriesOutputData),
);
